export default __webpack_public_path__ + "assets/favicon/R_favicon_default.0fc41914.ico";